import React, { useEffect, useState } from "react";
import ProductCard from "../ProductCard/ProductCard";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../App";
import BuyerServicesUrl from "../../BuyerServicesUrl";
import { mapProduct } from "../../models/Product/ProductResponseModel";
import "./ProductList.css";
import placeholder from "../../assets/placeholder.jpg";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


export default function ProductList() {
  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const section = params.get("section");
  const search = params.get("search");

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");

        // let type = "normal";
        // if (section === "featured") {
        //   type = "ads";
        // }
        let type = "ads"; // suggestions
if (section === "featured") {
  type = " normal"; // offers
}


        // 👇 Build URL dynamically
        let url = BaseUrl + BuyerServicesUrl.GetProductList;

        const queryParams = {};

        // لو في featured
        queryParams.type = type;

        // لو في search
        if (search) {
          queryParams.search = search;
        }

        const res = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: queryParams,
        });

        const mappedProducts =
          res.data?.data?.map(mapProduct) || [];

        setProducts(mappedProducts);
      } catch (err) {
        if (err.response?.status === 401) navigate("/login");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [navigate, section, search]);

  /* ================= LOADING ================= */
  // if (loading) {
  //   return (
  //     <div className="text-center mt-5 pt-5">
  //       <h4>Loading...</h4>
  //     </div>
  //   );
  // }
if (loading) {
  return (
    <div
      className="favorites-loader text-center pb-5"
      style={{ marginTop: "120px" , marginBottom:"170px" ,minHeight:"70vh"}}
    >
      <div className="loader-circle mb-3"></div>
      <p className="fw-bold">
        {search ? "جاري البحث..." : "جاري تحميل المنتجات..."}
      </p>
    </div>
  );
}
  /* ================= EMPTY STATE ================= */
  if (!products.length) {
    return (
      <div className="text-center mt-5 pt-5">
        <h4>
          {search
            ? `لا توجد نتائج بحث عن "${search}"`
            : "لا توجد منتجات حالياً"}
        </h4>
      </div>
    );
  }

  return (
    <div className="productList" style={{ marginTop: "190px" }}>
            <ToastContainer
      position="bottom-right"
      autoClose={2000}
      rtl
      theme="colored"
    />
      {/* <h3 className="container mb-4 fw-bold">
        {search
          ? `نتائج البحث عن "${search}"`
          : section === "suggesion"
          ? " " 
          : ""}
      </h3> */}
      <h3 className="container mb-4 fw-bold">
  {search
    ? `نتائج البحث عن "${search}"`
    : section === "featured"
    ? "كل عروض طوق نجاة"
    : section === "suggestion"
    ? "كل الإقتراحات"
    : "كل عروض طوق نجاة"}
</h3>

      <div className="row mt-3 container">

        {products.map((item) => (
          <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={item.id}>
            <ProductCard product={item} />
          </div>
          
        ))}
      </div>
    </div>
  );
}
